var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDirections({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 28,
    viewBox: "0 0 23 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639 31C11.3185 30.9468 11.1852 30.8642 11.0718 30.7572C10.9584 30.6502 10.8674 30.5209 10.8042 30.3772L3.03445 17.6467C1.76323 15.6477 1.20268 13.2649 1.44631 10.8954C1.64235 8.77651 2.49858 6.77716 3.88963 5.19032C5.01604 3.87978 6.44834 2.88005 8.05411 2.28348C9.65989 1.68692 11.3872 1.5128 13.0765 1.77729C14.7231 2.04996 16.2786 2.73176 17.6057 3.76237C18.9328 4.79298 19.9907 6.14081 20.6861 7.68691C21.3815 9.23302 21.693 10.9298 21.5931 12.6276C21.4932 14.3255 20.9849 15.9723 20.1132 17.4225L12.5145 30.3273C12.3726 30.6129 12.14 30.8412 11.8548 30.9751L11.4639 31Z",
    stroke: "#FFD705",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5124 15.3798C10.8455 15.3798 10.1936 15.1782 9.63914 14.8004C9.08465 14.4227 8.65248 13.8858 8.39727 13.2575C8.14207 12.6293 8.07532 11.938 8.20542 11.2711C8.33552 10.6042 8.65667 9.99156 9.12823 9.51076C9.59978 9.02995 10.2005 8.70265 10.8546 8.56999C11.5087 8.43734 12.1866 8.50532 12.8027 8.76553C13.4189 9.02575 13.9455 9.46648 14.316 10.0318C14.6865 10.5972 14.8842 11.2619 14.8842 11.9418C14.8842 12.8536 14.5289 13.7281 13.8966 14.3729C13.2643 15.0176 12.4067 15.3798 11.5124 15.3798Z",
    stroke: "#FFD705",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirections);
export default __webpack_public_path__ + "static/media/directions.dd353ae45bc2b8f55f2abad1c70fab00.svg";
export { ForwardRef as ReactComponent };